export default (state = {}, action) =>{
    switch(action.type){
        case 'DATA_PENDING':
            return {...state, data: action.payload} ;
        case 'PXQ_PENDING':
            return { ...state, pxqUrl: action.payload };
       
        default: return state;
    }
}